import Scrollable from './Scrollable';

export { Props, forNode } from './Scrollable';
export default Scrollable;
